import { handleError, newInstanceProps, setAuthorizationBearer } from '../utils/axiosConfig';

export default function ({ store, $axios }, inject) {
  const axiosBackend = $axios.create(newInstanceProps);

  axiosBackend.onRequest((config) => {
    if (config.headers.common) {
      config.headers.common['Experience'] = store.getters['experience/getExperience'];
      config.headers.common['Accept-Language'] = store.$i18n.locale;
      setAuthorizationBearer(process.server, config, store.$cookies);
    }
  });

  axiosBackend.onError((error) =>
    handleError(error, store.$cookies, store.dispatch, process.env.COOKIES_DOMAIN)
  );
  axiosBackend.setBaseURL(process.env.BACKEND_API_BASE || process.env.GEO_API_URL);

  inject('axiosBackend', axiosBackend);
}
